<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Fotoğraf Galerisi</b-card-title>
      <div>
        <b-button
          variant="primary"
          class="mr-1"
          @click="setModal"
        >
          <FeatherIcon icon="UploadIcon" />
          Fotoğraf Yükle
        </b-button>
      </div>
    </b-card-header>
    <b-card-body>
      <!-- Yüklenen görselleri göster -->
      <div
        v-if="itemData.images.length > 0"
        class=" p-0 row"
      >
        <draggable
          v-model="images"
          tag="ul"
          class="cursor-move p-0 row match-height"
          @update="updateImageOrder"
        >
          <div
            v-for="(image, index) in images"
            :key="index"
            tag="li"
            class="col-auto col-md-3"
          >
            <div
              class="border-light rounded p-1 mb-2 bg-light-primary"
            >
              <div
                class="overflow-hidden"
                style="max-height: 140px"
              >
                <b-img
                  :src="baseURL + '/media/references_media/' + image.filename"
                  fluid
                  class="h-auto w-100"
                />
              </div>
              <div class="border-top mt-1 d-flex justify-content-around">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  pill
                  class="btn-icon mt-1"
                  @click="removeImage( 'references_media',image, index)"
                >
                  <FeatherIcon icon="TrashIcon" />
                </b-button>
              </div>
            </div>
          </div>
        </draggable>
        <hr>
      </div>
      <!-- Yükleme bölümü -->
      <div v-if="modalOpen">
        <b-form-file
          id="image-files"
          v-model="selectedImages"
          class="mt-1"
          placeholder="Dosyalar seçin veya buraya bırakın..."
          drop-placeholder="Dosyaları buraya bırakın..."
          browse-text="Dosyalar Seçin"
          multiple
        />
        <div class="mt-1">
          <b-button
            variant="primary"
            :disabled="!selectedImages.length"
            @click="uploadFiles"
          >
            <FeatherIcon icon="UploadIcon" />
            Görseller Yükle
          </b-button>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BImg, BButton, BAlert, BFormFile,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'

export default {
  name: 'PhotoGallery',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BImg,
    BButton,
    BAlert,
    BFormFile,
    draggable,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      images: [], // Galeride gösterilecek tüm görseller
      selectedImages: [], // Yüklenmek üzere seçilen görseller
      modalOpen: false, // Yükleme modalinin açık olup olmadığını kontrol eder
    }
  },
  computed: {
    itemData() {
      const data = this.$store.getters['references/dataItem']
      if (data) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.images = data.images
      }
      return data
      // return this.$store.getters['references/dataItem']
    },
  },
  // watch: {
  //   images() {
  //     this.$store.dispatch('references/reOrderingImages', this.images)
  //   },
  // },
  methods: {
    setModal() {
      this.modalOpen = !this.modalOpen
    },
    uploadFiles() {
      const uploadPromises = this.selectedImages.map(file => {
        const formData = new FormData()
        formData.append('file', file)

        return this.$store.dispatch('fileUpload/uploadFile', {
          upload_file: file,
          folder: 'references_media',
        })
      })

      Promise.all(uploadPromises)
        .then(responses => {
          responses.forEach(response => {
            this.itemData.images.push({
              id: null,
              title: null,
              filename: response.filename,
              thumb: response.filename,
            })
          })
          this.selectedImages = [] // Yükleme sonrası seçimleri temizle
          this.modalOpen = false // Modalı kapat
        })
        .catch(error => {
          console.error('Dosya yükleme hatası:', error)
        })
    },
    removeImage(folder, image, index) {
      this.$store.dispatch('references/saveImage', image)
      this.$store.dispatch('references/removeImageData', {
        folder,
        image,
      })
        .then(response => {
          if (response) {
            this.dataItem.images.splice(index, 1)
          }
        })
        .catch(error => {
          console.error('Görsel silme hatası:', error)
        })
    },
    updateImageOrder() {
      // Update the order in the store after dragging
      this.$store.dispatch('references/reOrderingImages', this.images)
    },
  },
}
</script>
